import * as React from 'react';

function SvgUTorrentFilled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" className="UTorrentFilled_svg__icon" viewBox="0 0 1024 1024" {...props}>
      <path d="M1024 512.319C1024 229.58 794.738.372 512 .372 229.21.372 0 229.635 0 512.32c0 217.94 136.452 403.615 328.346 477.448l-96.638-449.169-27.323-126.937-48.372-224.531 187.376-40.346 69.262 322.073c18.711 86.964 58.153 133.635 123.11 119.601 51.402-11.056 73.196-52.89 79.043-84.89 2.605-12.12.691-27.11-2.498-41.78L535.6 107.374l187.323-40.239 87.495 406.698c35.189 163.561 130.445 188.598 130.445 188.598l-182.485 39.23c-53.794 11.64-90.047-84.572-90.047-84.572l-3.72.797c-15.31 41.728-32.585 109.502-166.22 138.312a282.578 282.578 0 01-28.81 4.412l56.558 263.017c276.093-7.495 497.86-233.356 497.86-511.31z" />
    </svg>
  );
}

export default SvgUTorrentFilled;
